export default __webpack_public_path__ + "static/media/product-quotes.92d8a261.svg";